module.exports = __webpack_public_path__ + "img/connect-wallet-button.968e6b18.png";